<template>
  <label class="products-filter-field">
    <span><b-icon icon="box-seam"></b-icon> نوع</span>
    <select @change="productTypeFilter" v-model="productType" class="products-filter-input">
      <option value="">همه</option>
      <option value="0">فیزیکی</option>
      <option value="1">دیجیتال</option>
    </select>
  </label>
</template>

<script>
export default {
  name: "ProductType",
  data() {
    return {
      productType: '',
    }
  },
  methods: {
    productTypeFilter() {
      this.$store.commit("Product/setFilters", {key: "is_digital", value: this.productType});
      this.$emit('updateFilter', {is_digital: this.productType})
      this.$store.dispatch('Product/setDashboardProducts', 1)
    }
  },
  mounted() {
    const value = this.$route.query.is_digital;
    if (value != undefined) {
      this.productType = value
      this.$store.commit('Product/setFilters', {key: 'is_digital', value: value})
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "is_digital", value: ''});
  }
}
</script>
